import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://welfbvblcqjtimwroywd.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndlbGZidmJsY3FqdGltd3JveXdkIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzA5MzIxOTIsImV4cCI6MTk4NjUwODE5Mn0.n8HcI5lpkVZ9CIj6uZqXDLH92a1eC8ZQGQ-3-e3uCXM";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
